import { useMemo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";

import GridCard from "components/GridCard";
import { LOAD_ITEMS } from "constants/loads";
import { useColorScheme } from "hooks/useColorScheme";
import { useUserFeature } from "hooks/useUserFeature";
import MainLayout from "layouts/Main";
import { selectAccount } from "store/auth/selector";
import styles from "./style.module.scss";

export default function LoadManage() {
  const { currentIsDark } = useColorScheme();
  const { isShipper, isPostLoadRole } = useUserFeature();
  const { userPermission } = useSelector(selectAccount);

  const selectedData = useMemo(() => {
    let items = LOAD_ITEMS ?? [];
    if (isShipper) {
      items = items.filter((pay) => pay.label !== "Load Search");
    }
    if (!userPermission?.can_post_loads) {
      items = items.filter((pay) => pay.label !== "Post Load");
    }
    if (!isPostLoadRole) {
      items = items.filter((pay) => pay.label !== "My Loads");
    }

    return items;
  }, [isShipper, userPermission, isPostLoadRole]);

  return selectedData ? (
    <MainLayout title="Loads" className="ml-4 mr-5">
      <div
        className={clsx(styles.loadGrid, !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]")}>
        {selectedData?.map((item) => <GridCard key={item.id} item={item} />)}
      </div>
    </MainLayout>
  ) : null;
}
